import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-thankyou-page",
    templateUrl: "./thankyou-page.component.html",
    standalone: false
})
export class ThankyouPageComponent implements OnInit {
  id: string;
  constructor(private translateService: TranslateService, private route: ActivatedRoute) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.id = this.route.snapshot.params["id"];
  }
}
